"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * @author OPt
 */


var WindowImportValidationErrorConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(WindowImportValidationErrorConverter, _DataObjectConverter_);

  function WindowImportValidationErrorConverter() {
    _classCallCheck(this, WindowImportValidationErrorConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowImportValidationErrorConverter).apply(this, arguments));
  }

  return WindowImportValidationErrorConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.WindowImportValidationErrorConverter = WindowImportValidationErrorConverter;